import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {RouterLink} from "@irati/ui/src/Link"
import authentication from "@irati/auth"

const idNamespace = "secondaryNav"

interface Props {
  pathname: string
}

const RecognitionMenuLink = ({pathname}: Props) => {
  const canReward = authentication.apps("recognition.rewards.create")
  const isRewardDisabled = authentication.apps("recognition.recognition.rewardDisabled")
  const hasFlexiRewards = authentication.apps("wallet.flexiRewards")

  if (!isRewardDisabled && !hasFlexiRewards) {
    return (
      <>
        <RouterLink
          plain
          id={id("link-polls", idNamespace)}
          to="/polls"
          className={pathname.includes("/polls") && "active"}>
          <FormattedMessage id="recognition.navigation.recognition" />
        </RouterLink>
        {canReward && (
          <RouterLink
            plain
            id={id("link-reward", idNamespace)}
            to="/reward"
            className={pathname.includes("/reward") && "active"}>
            <FormattedMessage id="recognition.navigation.reward" />
          </RouterLink>
        )}
      </>
    )
  }
  return null
}

export default RecognitionMenuLink
